import { render, staticRenderFns } from "./SmartEditor.vue?vue&type=template&id=532e1cb0&scoped=true"
import script from "./SmartEditor.vue?vue&type=script&lang=js"
export * from "./SmartEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e1cb0",
  null
  
)

export default component.exports